import api from './api';

const studentShopAPI = {
  getMeta: () => api.get('/student-shop/meta'),
  getClassItems: (classId, params = {}) => api.get(`/student-shop/class/${classId}`, { params }),
  getClassRecords: (classId, params = {}) => api.get(`/student-shop/records/${classId}`, { params }),
  createItem: (data) => api.post('/student-shop', data),
  updateItem: (id, data) => api.put(`/student-shop/${id}`, data),
  deleteItem: (id) => api.delete(`/student-shop/${id}`),
  exchangeItem: (data) => api.post('/student-shop/exchange', data),
  updateRecordStatus: (id, data) => api.patch(`/student-shop/records/${id}/status`, data),
  refundRecord: (id, data) => api.post(`/student-shop/records/${id}/refund`, data)
};

export default studentShopAPI;
